import { render, staticRenderFns } from "./SchoolControlReportIndex.vue?vue&type=template&id=342ec715"
import script from "./SchoolControlReportIndex.js?vue&type=script&lang=js&external"
export * from "./SchoolControlReportIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports